// extracted by mini-css-extract-plugin
var _1 = "eHOG5zKuLL vI8xdh1gLj";
var _2 = "VAOCN9Fvua";
var _3 = "LjZseNW9JM";
var _4 = "N5Ji_Wj78f";
var _5 = "au_O7XZeMg";
var _6 = "TURoqOzCb1";
export { _1 as "award", _2 as "gold", _3 as "icon", _4 as "message", _5 as "shimmer", _6 as "success" }
